export default "__VITE_ASSET__DyACSXC6__"